import { MenuItem as PrimeMenuItem } from "primeng/api";
import { MenuItem } from "./menu-item.model";

// TODO: Create spec file.
export abstract class GenericMenuComponent {
  items: MenuItem[] = [];

  get hasItems(): boolean {
    return this.items.length > 0;
  }

  private primeMenuItems = [];
  private get hasMenuItems(): boolean {
    return this.primeMenuItems.length > 0;
  }
  get menuItems(): PrimeMenuItem[] {
    if (this.hasItems && !this.hasMenuItems) {
      this.primeMenuItems = this.toPrimeMenuItems(this.items);
    }

    return this.primeMenuItems;
  }


  toPrimeMenuItems(items: MenuItem[]) {
    return items.filter(item => item.show).map(this.toPrimeMenuItem);
  }

  private toPrimeMenuItem = (item: MenuItem): PrimeMenuItem => {
    const children = item.hasChildren ? this.toPrimeMenuItems(item.children) : null;
    return this.getPrimeMenuItem(
      item.description,
      item.iconName,
      item.path,
      item.show,
      children);
  }

  private getPrimeMenuItem(
    label: string,
    icon: string,
    path: string,
    show: boolean,
    items: PrimeMenuItem[]
  ): PrimeMenuItem {
    return {
      label,
      icon: `fa fa-${icon}`,
      routerLink: [path],
      items,
      show,
    } as any;
  }
}
